module.exports = __webpack_public_path__ + "img/logo.5cd79394.png";